import type { BlockRecord } from '@/lib/blocks/types';

export function findSidebarParentId(
  blockId: string,
  childrenByParent: Record<string, readonly { id: string }[]>,
): string | null {
  for (const parentId of Object.keys(childrenByParent)) {
    if (childrenByParent[parentId]?.some((child) => child.id === blockId)) {
      return parentId;
    }
  }
  return null;
}

export function navRootBlocks(blocks: readonly BlockRecord[]): BlockRecord[] {
  return blocks.filter((block) => block.parentId == null && block.type === 'page');
}

/**
 * Group nav rows by parent. Every page gets a list, including an empty one,
 * so the sidebar can tell a leaf from a folder that has not been loaded.
 */
export function buildSidebarChildrenIndex(
  blocks: readonly BlockRecord[],
): Record<string, BlockRecord[]> {
  const childrenByParent: Record<string, BlockRecord[]> = {};
  for (const block of blocks) {
    if (block.parentId == null) {
      continue;
    }
    const list = childrenByParent[block.parentId];
    if (list) {
      list.push(block);
    } else {
      childrenByParent[block.parentId] = [block];
    }
  }
  for (const block of blocks) {
    if (block.type === 'page' && childrenByParent[block.id] === undefined) {
      childrenByParent[block.id] = [];
    }
  }
  return childrenByParent;
}
